import {
  agents,
  detectGlobalAgents,
  detectProjectAgents,
  getAgentTypes,
  getConfigKey,
  getConfigPath2 as getConfigPath,
  getNestedValue,
  installServerForAgent,
  listInstalledServers,
  readConfig,
  removeServerFromConfig
} from "./chunk-4EL5LX2K.js";

// src/lib.ts
import { existsSync } from "fs";
function isKnownAgent(agentType) {
  return Object.prototype.hasOwnProperty.call(agents, agentType);
}
function validate(agentType, local) {
  if (!isKnownAgent(agentType)) {
    return `Unknown agent type: ${String(agentType)}`;
  }
  if (local && !agents[agentType].localConfigPath) {
    return `${agentType} does not support project-level config`;
  }
  return null;
}
function upsertServer(agentType, serverName, serverConfig, options = {}) {
  const error = validate(agentType, options.local);
  if (error) return { success: false, path: "", error };
  return installServerForAgent(
    serverName,
    serverConfig,
    agentType,
    options
  );
}
function hasServer(serversObj, serverName) {
  return !!serversObj && typeof serversObj === "object" && !Array.isArray(serversObj) && Object.prototype.hasOwnProperty.call(serversObj, serverName);
}
function doRemove(agentType, serverName, options) {
  const agent = agents[agentType];
  const configPath = getConfigPath(agent, options);
  const configKey = getConfigKey(agent, options);
  if (!existsSync(configPath)) {
    return { success: true, path: configPath, removed: false };
  }
  const fullConfig = readConfig(configPath, agent.format);
  if (!hasServer(getNestedValue(fullConfig, configKey), serverName)) {
    return { success: true, path: configPath, removed: false };
  }
  removeServerFromConfig(configPath, agent.format, configKey, serverName);
  return { success: true, path: configPath, removed: true };
}
function removeServer(agentType, serverName, options = {}) {
  const error = validate(agentType, options.local);
  if (error) return { success: false, path: "", removed: false, error };
  const known = agentType;
  try {
    return doRemove(known, serverName, options);
  } catch (e) {
    return {
      success: false,
      path: getConfigPath(agents[known], options),
      removed: false,
      error: e instanceof Error ? e.message : "Unknown error"
    };
  }
}
export {
  agents,
  detectGlobalAgents,
  detectProjectAgents,
  getAgentTypes,
  listInstalledServers,
  removeServer,
  upsertServer
};
